import suporterImage from "@/assets/images/sponsorship/suporter.png";

// Scène illustrée festive : hero clair (inverse chromatique du hero
// pronostics) — dominante blanche, trois blobs pastel flous, une pincée de
// confettis dessinés statiques et une mascotte supporter contenue
// dans le bandeau. Titre à 70 % pour ménager la mascotte.
const DecorativeConfetti = () => (
  <svg
    aria-hidden
    className="pointer-events-none absolute inset-0 size-full"
    fill="none"
    viewBox="0 0 600 200"
    preserveAspectRatio="xMidYMid slice"
  >
    <circle cx="80" cy="38" r="5" className="fill-violet-300/70" />
    <rect x="150" y="120" width="9" height="9" rx="2" className="fill-emerald-300/70" transform="rotate(24 150 120)" />
    <circle cx="250" cy="30" r="4" className="fill-amber-300/80" />
    <rect x="330" y="140" width="8" height="8" rx="2" className="fill-rose-300/70" transform="rotate(-18 330 140)" />
    <circle cx="420" cy="52" r="5" className="fill-sky-300/70" />
    <rect x="500" y="26" width="9" height="9" rx="2" className="fill-violet-300/60" transform="rotate(40 500 26)" />
    <circle cx="545" cy="120" r="4" className="fill-emerald-300/60" />
    <rect x="60" y="150" width="8" height="8" rx="2" className="fill-amber-300/60" transform="rotate(12 60 150)" />
  </svg>
);

export const SponsorshipHero = () => (
  <section className="relative overflow-hidden rounded-lg bg-white px-6 pt-8 pb-8 dark:bg-gray-900 md:px-10 md:pt-10 md:pb-10">
    <div aria-hidden className="pointer-events-none absolute -top-16 -left-10 size-48 rounded-full bg-violet-200/60 blur-3xl dark:bg-violet-900/40" />
    <div aria-hidden className="pointer-events-none absolute -bottom-20 left-1/3 size-56 rounded-full bg-emerald-200/50 blur-3xl dark:bg-emerald-900/30" />
    <div aria-hidden className="pointer-events-none absolute -top-10 right-8 size-44 rounded-full bg-amber-200/50 blur-3xl dark:bg-amber-900/30" />
    <DecorativeConfetti />

    <div className="relative max-w-[70%] space-y-3 md:max-w-2xl">
      <h1 className="text-3xl font-bold tracking-tight text-gray-900 dark:text-white md:text-4xl">
        Parrainage
      </h1>
      <p className="text-sm text-gray-600 dark:text-gray-300 md:text-base">
        Recommandez Yeati à un autre CSE, gagnez des points, convertissez-les en euros.
      </p>
    </div>

    <img
      src={suporterImage}
      alt=""
      aria-hidden
      className="pointer-events-none absolute -bottom-6 right-4 h-32 select-none drop-shadow-xl md:-bottom-10 md:h-52"
    />
  </section>
);

SponsorshipHero.displayName = "SponsorshipHero";
